export default {
  about: 'about',
  home: 'home',
  langs: {
    en: 'English',
    fr: 'Français',
    it: 'Italiano',
  },
}
